import { substituteFormName } from '../event-factories';
import {
  FormAttributionAttributes,
  FormAttributionInteraction,
} from '../types';
import { getIsFormEnabled, logger } from '../utils';

import { trackEvent } from './event-tracker';

export const createFormSubmissionHandler = () => (event: SubmitEvent) => {
  const target = event.target;

  if (!(target instanceof HTMLFormElement)) {
    return;
  }

  const isEnabled = getIsFormEnabled(target);

  if (!isEnabled) {
    logger.warn(
      `Dropping form attribution event due to disabled form. The dropped form contains the attribute \`${FormAttributionAttributes.FormEnabled}\` with a value which evaluates to false.`,
      target,
    );

    return;
  }

  const formName = target?.name;

  if (typeof formName === 'undefined') {
    logger.warn(`Dropping form submit event due to missing form name:`, target);

    return;
  }

  trackEvent({
    event_name: 'form',
    form_name: substituteFormName(formName),
    form_interaction: `${FormAttributionInteraction.Click}.button.submit`,
  });
};
